import { render, staticRenderFns } from "./AppliedMedicalPaymentListTable.vue?vue&type=template&id=40c0db78&scoped=true&"
import script from "./AppliedMedicalPaymentListTable.vue?vue&type=script&lang=js&"
export * from "./AppliedMedicalPaymentListTable.vue?vue&type=script&lang=js&"
import style0 from "./AppliedMedicalPaymentListTable.vue?vue&type=style&index=0&id=40c0db78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c0db78",
  null
  
)

export default component.exports